import { getFederateConfig } from "src/config/Federate";
import { Cookie } from "src/constants/Cookie";
import { cookie } from "src/utils/Cookie";
import { getRandomString } from "src/utils/StringUtil";
import { CookieSetOptions } from "universal-cookie";

const urlParams = new URLSearchParams(window.location.search);
const federateConfig = getFederateConfig();

const setCookie = (token: string) => {
    const expiresInMin = Cookie.EXPIRATION_TIME;
    let date = new Date();
    date.setTime(date.getTime() + expiresInMin * 60 * 1000);
    const options: CookieSetOptions = { path: "/", expires: date, sameSite: "lax", secure: true };
    cookie.set(Cookie.TOKEN, token, options);
};

const generateCodeChallenge = async (verifier: string): Promise<string> => {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};

export const authorizeUser = async () => {
    let code = urlParams.get("code");
    let state = urlParams.get("state");
    if (!code || !state) {
        // PKCE
        state = getRandomString();
        sessionStorage.setItem(Cookie.PKCE_STATE, state);
        // Code Verifier
        const code_verifier = getRandomString();
        sessionStorage.setItem(Cookie.CODE_VERIFIER, code_verifier);
        const code_challenge = await generateCodeChallenge(code_verifier);

        const params = new URLSearchParams({
            client_id: federateConfig.CLIENT_ID,
            response_type: "code",
            state: state,
            scope: "openid",
            redirect_uri: federateConfig.REDIRECT_URI,
            code_challenge: code_challenge,
            code_challenge_method: "S256",
        });
        window.location.href = federateConfig.AUTH_URL + "?" + params.toString();
    }
    else {
        if (sessionStorage.getItem(Cookie.PKCE_STATE) !== state) {
            console.warn("Invalid state!");
            cookie.remove(Cookie.TOKEN);
        }
        else {
            const existingIdToken = cookie.get(Cookie.TOKEN);
            if (!existingIdToken) {
                const code_verifier = sessionStorage.getItem(Cookie.CODE_VERIFIER) || "";
                const response = await fetch(federateConfig.TOKEN_URL, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams({
                        grant_type: "authorization_code",
                        client_id: federateConfig.CLIENT_ID,
                        redirect_uri: federateConfig.REDIRECT_URI,
                        code,
                        code_verifier,
                    })
                });
                const body = await response.json();
                const id_token = body.id_token;
                if (id_token) {
                    setCookie(id_token);
                    return id_token;
                }
            }
        }
    }
}
